module.exports = __webpack_public_path__ + "static/media/baseMeme3.1d4c6ca0.jpg";